import { render, staticRenderFns } from "./sider-menu-shrinked.vue?vue&type=template&id=640999fe&scoped=true&"
import script from "./sider-menu-shrinked.vue?vue&type=script&lang=js&"
export * from "./sider-menu-shrinked.vue?vue&type=script&lang=js&"
import style0 from "./sider-menu-shrinked.vue?vue&type=style&index=0&id=640999fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640999fe",
  null
  
)

export default component.exports